export default function baseIsNaN(data) {
  return data !== data
}
